/**
 * Course program outline.
 */
import React from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

import { useAsterController } from "context";
import { VText } from "form";
import CourseProgramItem from "./course.program.item";
import { BEmpty } from "components";

/**
 * Lists course sections the learner can open.
 */
const CourseProgram = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { structure, loadedCourseDetail } = controller;
  const sections = structure.sections || []

  return (
    <>
      <Box>
        <Box className="w-full">
          <VText className="text-2xl font-bold">{t("Course contents")}</VText>
        </Box>
          {loadedCourseDetail || sections.length
            ? (
              sections.length ? (
                <Box className="w-full md:my-8 my-2">
                  {
                    sections.map((section, sectionIdx) => <CourseProgramItem key={section.section_id} section={section} sectionIdx={sectionIdx} />)
                  }
                </Box>
              )
              :
              <BEmpty />
            )
            : 
            [...Array(10).keys()].map((v) => (
              <Box className="mb-2" key={v}>
                <Box className="flex justify-between items-center w-full rounded-md border border-solid border-gray-300 dark:border-gray-500 md:border-l-8 border-l-4 px-2 md:px-10 py-3 md:py-5 cursor-pointer" style={{ borderLeftColor: "var(--color_main1)" }}>
                  <Skeleton containerClassName="max-w-sm w-full h-6" className="w-full h-full" />
                  <Icon icon="bi:chevron-right" />
                </Box>
              </Box>
            ))
          }
        </Box>
    </>
  );
};

export default CourseProgram;
